import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useOnboardingActions } from './OnboardingActionsContext';
import { SectionMarker } from '../components/SectionMarker';
import { FooterState } from '../components/FooterState';
const INTENT_OPTIONS = [
    'focus',
    'memory',
    'speed',
    'social',
    'curiosity',
];
const STORAGE_KEY = 'labrain.onboarding.intent';
/**
 * Onboarding step 4 — Q intent (DEC-014 utility-first cyanotype).
 *
 * Optionnel (skip allowed). 5 options : focus / memoire / vitesse / social
 * / curiosite. Stocke dans localStorage labrain.onboarding.intent pour
 * personnalisation future de la session du jour. Apres choix ou skip,
 * navigate -> /.
 */
export function Intent() {
    const { t } = useTranslation('onboarding');
    const navigate = useNavigate();
    const { setActions } = useOnboardingActions();
    const [selected, setSelected] = useState(null);
    useEffect(() => {
        setActions(_jsx("button", { type: "button", onClick: () => {
                if (selected) {
                    try {
                        window.localStorage.setItem(STORAGE_KEY, selected);
                    }
                    catch {
                        /* ignore quota / private mode */
                    }
                }
                navigate('/');
            }, disabled: selected === null, className: `
          inline-flex h-11 w-full items-center justify-center
          font-display text-[14px] font-medium tracking-[-0.02em]
          transition active:scale-[0.98]
          ${selected
                ? 'bg-cyan-core text-cyan-surface hover:bg-cyan-media'
                : 'cursor-not-allowed bg-cyan-text-faint/40 text-cyan-surface'}
        `, children: t('intent.cta') }));
        return () => setActions(null);
    }, [selected, navigate, setActions, t]);
    return (_jsxs("article", { className: "flex flex-1 flex-col gap-5 pt-2", children: [_jsxs("header", { className: "flex flex-col gap-3", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx(SectionMarker, { num: "04", label: t('flow.step', { current: 4, total: 4 }) }), _jsx("button", { type: "button", onClick: () => navigate('/'), className: "font-mono text-[10px] uppercase tracking-[0.15em] text-cyan-text-secondary hover:text-cyan-core", children: t('intent.skip') })] }), _jsx("h1", { className: "font-display text-[28px] font-medium leading-[1.05] tracking-cy-display text-cyan-text", children: t('intent.title') }), _jsx("p", { className: "text-[13px] font-light leading-5 text-cyan-text-secondary", children: t('intent.body') })] }), _jsxs("fieldset", { className: "flex flex-col gap-2", children: [_jsx("legend", { className: "sr-only", children: t('intent.title') }), INTENT_OPTIONS.map((opt) => {
                        const isSel = selected === opt;
                        return (_jsxs("label", { className: `
                card-blueprint flex cursor-pointer items-center justify-between
                px-4 py-3
                transition
                ${isSel ? 'border-cyan-network bg-cyan-bg' : 'hover:border-cyan-text-faint'}
              `, children: [_jsxs("span", { className: "flex flex-col gap-1", children: [_jsx("span", { className: "font-display text-[14px] font-medium tracking-[-0.02em] text-cyan-text", children: t(`intent.options.${opt}.label`) }), _jsx("span", { className: "text-[12px] font-light text-cyan-text-secondary", children: t(`intent.options.${opt}.desc`) })] }), _jsx("input", { type: "radio", name: "intent", value: opt, checked: isSel, onChange: () => setSelected(opt), className: "h-[16px] w-[16px] accent-cyan-core" })] }, opt));
                    })] }), _jsx("div", { className: "mt-auto pt-4", children: _jsx(FooterState, { state: selected
                        ? `1 / ${INTENT_OPTIONS.length} sélectionné`
                        : `0 / ${INTENT_OPTIONS.length} sélectionnés`, coord: "O\u201404 \u00B7 001" }) })] }));
}
//# sourceMappingURL=Intent.js.map